import React from 'react';

import { MOBILE_SCREEN, useDeviceType } from '@travel/traveler-core/hooks';
import { ImagePlaceHolder } from '@travel/ui';
import { GalleryMedia } from '@travel/ui/components/Gallery';

import RoomPlanGalleryCover from '../RoomPlanGalleryCover';

import styles from './roomPlanItemHeader.module.scss';

type Props = {
  title?: string;
  displayImage?: GalleryMedia;
  media: Array<GalleryMedia>;
  onDisplayGallery: (index: number) => void;
  infoComponent?: JSX.Element;
  onDisplayDetail: () => void;
  /** is first */
  isFirst: boolean;
};

function RoomPlanItemHeader(props: Props) {
  const {
    title,
    displayImage,
    media,
    onDisplayGallery,
    infoComponent,
    onDisplayDetail,
    isFirst,
  } = props;

  const deviceType = useDeviceType();
  const isMobile = deviceType === MOBILE_SCREEN;

  const nameButton = (
    <div className={styles.nameButtonWrapper}>
      <button
        className={styles.nameButton}
        onClick={onDisplayDetail}
        data-testid="roomPlanItemHeader-nameButton"
      >
        <h3 className={styles.name} data-testid="roomPlanItemHeader-name">
          {title}
        </h3>
      </button>
    </div>
  );

  return (
    <>
      <div className={styles.wrapper} data-testid="providerInfo-roomPlanItemHeader">
        {!isMobile && nameButton}
        <div className={styles.detailsWrapper}>
          {displayImage ? (
            <RoomPlanGalleryCover
              medias={media}
              onOpenGallery={onDisplayGallery}
              onOpenDetail={onDisplayDetail}
              isFirst={isFirst}
            />
          ) : !isMobile ? (
            <ImagePlaceHolder className={styles.imagePlaceHolder} />
          ) : null}
          {!isMobile && infoComponent}
        </div>
      </div>
      {isMobile && nameButton}
      {isMobile && <div className={styles.infoBox}>{infoComponent}</div>}
    </>
  );
}

export default RoomPlanItemHeader;
